<template>
  <b-card header-tag="header">
    <h3 slot="header">Student Volunteer Application</h3>
    <h4 v-if="isLoading">Getting your application...</h4>
    <div class="card-text" v-if="isLoaded">
      <div v-if="isNewApp" class="row">
        <div v-if="isTeamLeader" class="col">
        </div>
        <div v-else class="col">
          <h2>Applications Have Closed</h2>
          <p>The deadline for submissions has passed and we are now processing completed applications.</p>
        </div>
      </div>
      <div v-if="completed" class="row">
        <div v-if="isAccepted && !isTeamLeader" class="col">
          <h2 class="mb-2">Welcome to the SIGGRAPH SV Family!</h2>
          <p>Congratulations on being accepted as a Student Volunteer for this year's conference!</p>
          <p>This page will be your Dashboard where you can access Scheduling features in the near future.</p>
          <p>If for some reason you are unable to attend, you can decline your position by emailing us at <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>.</p>
          <!-- <button type="button" v-b-modal.confirm-decline-1 class="btn btn-lg btn-black">Decline
            Position</button>
            <b-modal id="confirm-decline-1" @ok="declineAcceptance" ok-title="Decline" no-close-on-backdrop title="Decline Acceptance">
              <p>Are you sure you want to decline your position as a Student Volunteer?</p>
            </b-modal> -->
        </div>
        <div v-else-if="isTeamLeader" class="col">
          <h2 class="mb-2">Welcome to the SIGGRAPH SV Family!</h2>
          <p>Congratulations on being accepted as a Team Leader for this year's conference!</p>
          <p>This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.</p>
        </div>
        <div v-else-if="isOffered && !isTeamLeader && isAfterDecisionsOut" class="col">
          <div v-if="isAfterConfirmationDeadline">
            <h2>The confirmation deadline has passed.</h2>
            <p>The acceptance confirmation deadline for first round acceptances was <strong>{{formattedDate(confirmationDeadline)}}</strong>. If you have questions please email <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>.</p>
          </div>
          <div v-else>
            <h2>Congratulations!<br />You've been accepted as a Student Volunteer!</h2>
            <p>Now that you've been accepted, we need your confirmation of attendence.</p>
            <p>Please spend some time on this confirmation form so we know that you're able to come.
              This will also help us better accomodate you and make sure you have a great experience at SIGGRAPH.</p>
            <p>Please confirm or decline your position no later than <strong>{{formattedDate(confirmationDeadline)}}</strong>.</p>
            <div class="row justify-content-center">
              <div class="col-4">
                <button type="button" @click="goToConfirmationForm" class="btn btn-lg btn-black">Confirm</button>
              </div>
              <div class="col-4">
                <button type="button" v-b-modal.confirm-decline class="btn btn-lg btn-black">Decline</button>
                <b-modal id="confirm-decline" @ok="declineAcceptance" ok-title="Decline" cancel-title="I'm not sure" no-close-on-backdrop centered title="Decline Acceptance">
                  <p>Are you sure you want to decline your position as a Student Volunteer?</p>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="isDeclined" class="col">
          <h2 class="mb-2">Sorry you aren't able to make it!</h2>
          <p>You've declined the invitation to be a Student Volunteer. If this is a mistake, please contact us immediately
            at <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>.</p>
          <p>The deadline for confirmations was <strong>{{formattedDate(confirmationDeadline)}}</strong>.</p>
        </div>
        <div v-else-if="isPending && isAfterDecisionsOut" class="col">
          <h2>Thank You For Applying!</h2>
          <p>Our team reviewed a highly competitive pool of applications, and your submission stood out with strong potential.</p>
          <p>While we’re not able to offer you a spot in the 2026 cohort at this time, we’ve placed you on the waitlist.</p>
          <h3>What this means:</h3>
          <ul style="list-style-type:square; padding-left:40px">
            <li>You are still under consideration for this year's program. If a confirmed SV cancels, we will contact you directly to offer you a spot.</li>
            <li>Waitlist updates will continue through late June, so keep an eye on your email.</li>
            <li>No action is needed on your part at this time. We will reach out if a spot becomes available.</li>
          </ul>
          <p>If your plans change and you no longer wish to participate, let us know as soon as possible so we can update your status and offer the opportunity to someone else.</p> 
           <p> Being waitlisted does not hurt your chances in the future. You’re welcome to apply again for any year you’re eligible. </p>
           <p>We appreciate the time and effort you put into your application. We hope to welcome you into the SV community soon</p>
          <p>If you would like to be removed from our waitlist or have any questions or concerns please reach out to us at: <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a> </p>
        </div>
        <div v-else-if="isRejected && isAfterDecisionsOut" class="col">
          <h2>Thank You For Applying!</h2>
          <p>Unfortunately we cannot offer you a Student Volunteer role at this time.</p>
          <p>We appreciate the time and effort you put into your application and encourage you to re-apply 
            for SIGGRAPH 2026!</p>
        </div>
        <div v-else class="col">
          <h2>Thank You For Applying!</h2>
          <p>You have successfully applied to the SIGGRAPH Student Volunteer Program. <br/>
          The deadline for submissions has passed and we are now processing completed applications.</p>
          <button type="button" @click="goToApp" class="btn arrow-btn-primary" style="margin-bottom: 1rem;"><div>View your Submission</div></button>
          <h4>Notification of Acceptance</h4>
          <p>You should hear from us around the following time: <strong>the last week of May</strong></p>
          <h4>Professional References</h4>
          <p>References will be contacted shortly after applications close. Please allow a few days for forms to be sent.
          </p>

        </div>
      </div>
      <div v-else>
        <div class="row">
          <div v-if="isTeamLeader" class="col">
            <h2>Welcome to the SIGGRAPH SV Family!</h2>
            <p>Congratulations on being accepted as a Team Leader for this year's conference!</p>
            <p>This page will be your Team Leader Dashboard where you can access Jury and Scheduling features.</p>
          </div>
          <div v-else-if="!isNewApp" class="col">
            <h2>Applications Have Closed</h2>
            <p>The deadline for submissions has passed.</p>
            <p>We begin processing completed applications immediately and we cannot accept late submissions.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4>Resources</h4>
        <ul style="list-style-type:square; padding-left:40px">
          <li><a href="https://s2026.siggraph.org" target="_blank">SIGGRAPH 2026</a></li>
          <li><a href="https://s2026.siggraph.org/program/student-volunteers/" target="_blank">Frequently Asked
              Questions</a></li>
        </ul>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import router from '@/router'
import moment from 'moment'

export default {
  name: 'SvAppStatus',
  data () {
    return {}
  },
  methods: {
    formattedDate: function (date) {
      return moment(date).tz('UTC').local().format('D MMMM YYYY [at] HH:mm')
    },
    goToConfirmationForm (e) {
      e.preventDefault()
      router.push('/confirmation')
    },
    declineAcceptance (e) {
      e.preventDefault()
      this.$store.dispatch('user/declineAcceptance').then(() => {
        // Reload application again to get the new status
        this.$store.dispatch('application/load')
      })
    },
    goToApp (e) {
      e.preventDefault()
      router.push('/application/view')
    }
  },
  computed: {
    ...mapGetters(['isAfterConfirmationDeadline', 'isAfterDecisionsOut']),
    ...mapGetters('application', ['isNewApp', 'isNotNewApp', 'isPending', 'isAccepted', 'isOffered', 'isDeclined', 'isRejected']),
    ...mapState('application', ['isLoaded', 'isLoading', 'completed']),
    ...mapState('user', ['profile', 'isTeamLeader']),
    ...mapState(['confirmationDeadline']),
    TLName () {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'Team Leader'
      } else {
        return this.profile.nickname
      }
    },
    SVName () {
      if (this.profile.nickname === '') {
        return this.profile.firstName !== '' ? this.profile.firstName : 'SV'
      } else {
        return this.profile.nickname
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load')
    }
    if (!this.$store.state.user.loadedAttributes) {
      this.$store.dispatch('user/loadAttributes')
    }
  }
}
</script>

<style lang="scss">
  .modal-backdrop {
    background-color: rgba(0,0,0,0.7);
  }
</style>

<style scoped>
.card {
  margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppStatus.vue